import {
    BlogRollWidgetStyle, IBlogRollClassicWidgetStyle, IBlogRollEditorialWidgetStyle, IBlogRollMagazineWidgetStyle,
    IBlogRollWidgetData, BlogRollWidgetLayout, IBlogRollAllArticleContentWidgetStyle
} from "@pageBuilder/typings";
import { BlogRollClassicStylesRenderer } from "./blog-roll-classic-styles-renderer";
import { BlogRollMagazineStylesRenderer } from "./blog-roll-magazine-styles-renderer";
import { BlogRollEditorialStylesRenderer } from "./blog-roll-editorial-styles-renderer";
import { ElementStyleService } from "../../../services/element-style.service";
import { BlogRollAllArticleContentStylesRenderer } from "./blog-roll-all-article-content-styles-renderer";

export type BlogRollStylesRenderers = BlogRollMagazineStylesRenderer | BlogRollClassicStylesRenderer | BlogRollEditorialStylesRenderer;

export class BlogRollStylesRenderer {

    public magazineStyleRenderer: BlogRollMagazineStylesRenderer;
    public classicStylesRenderer: BlogRollClassicStylesRenderer;
    public editorialStylesRenderer: BlogRollEditorialStylesRenderer;
    public allArticleContentStylesRenderer: BlogRollAllArticleContentStylesRenderer;

    constructor(styleService: ElementStyleService) {
        this.magazineStyleRenderer = new BlogRollMagazineStylesRenderer(styleService);
        this.classicStylesRenderer = new BlogRollClassicStylesRenderer(styleService);
        this.editorialStylesRenderer = new BlogRollEditorialStylesRenderer(styleService);
        this.allArticleContentStylesRenderer = new BlogRollAllArticleContentStylesRenderer(styleService);
    }

    public render(element: HTMLElement, style: BlogRollWidgetStyle, layout: BlogRollWidgetLayout | null): void {
        switch (layout) {
            case BlogRollWidgetLayout.Classic: {
                this.classicStylesRenderer.render(element, style as IBlogRollClassicWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.Magazine: {
                this.magazineStyleRenderer.render(element, style as IBlogRollMagazineWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.Editorial: {
                this.editorialStylesRenderer.render(element, style as IBlogRollEditorialWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.AllArticleContent: {
                this.allArticleContentStylesRenderer.render(element, style as IBlogRollAllArticleContentWidgetStyle);
                break;
            }
            default: {
                throw("Style renderer doesn`t exist");
            }
        }
    }

    public getContentSelectorsInternal(element: HTMLElement, layout: BlogRollWidgetLayout): Array<string> {
        return this.getRenderer(layout).getStyleSelectors(element);
    }

    public cleanup(element: HTMLElement, layout: BlogRollWidgetLayout): void {
        return this.getRenderer(layout).cleanup(element);
    }

    public partialUpdateWithDefaults(data: IBlogRollWidgetData): void {
        switch (data.layout) {
            case BlogRollWidgetLayout.Classic: {
                this.classicStylesRenderer.partialUpdateWithDefaults(data.style as IBlogRollClassicWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.Magazine: {
                this.magazineStyleRenderer.partialUpdateWithDefaults(data.style as IBlogRollMagazineWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.Editorial: {
                this.editorialStylesRenderer.partialUpdateWithDefaults(data.style as IBlogRollEditorialWidgetStyle);
                break;
            }
            case BlogRollWidgetLayout.AllArticleContent: {
                this.allArticleContentStylesRenderer.partialUpdateWithDefaults(data.style as IBlogRollAllArticleContentWidgetStyle);
                break;
            }
            default: {
                throw("Style renderer doesn`t exist");
            }
        }
    }

    private getRenderer(layout: BlogRollWidgetLayout): BlogRollStylesRenderers {
        switch (layout) {
            case BlogRollWidgetLayout.Classic: {
                return this.classicStylesRenderer;
            }
            case BlogRollWidgetLayout.Magazine: {
                return this.magazineStyleRenderer ;
            }
            case BlogRollWidgetLayout.Editorial: {
                return this.editorialStylesRenderer;
            }
            case BlogRollWidgetLayout.AllArticleContent:
                return this.allArticleContentStylesRenderer;
            default: {
                throw("Style renderer doesn`t exist");
            }
        }
    }

}
